import { render, staticRenderFns } from "./ibox2.vue?vue&type=template&id=1650e3e2&"
import script from "./ibox2.vue?vue&type=script&lang=js&"
export * from "./ibox2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1650e3e2')) {
      api.createRecord('1650e3e2', component.options)
    } else {
      api.reload('1650e3e2', component.options)
    }
    module.hot.accept("./ibox2.vue?vue&type=template&id=1650e3e2&", function () {
      api.rerender('1650e3e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/widgets/ibox2.vue"
export default component.exports